import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoadingService } from './shared/loading/loading.service';
import { AutoUnsubscribe } from './core/decorators/auto-unsubscribe';
import {Router, NavigationStart, NavigationEnd, NavigationError, ActivatedRoute} from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { GetSessionProfileService } from './login/services/get-session-profile.service';
import { ToastrService } from 'ngx-toastr';
import { GetCurrentFilialService } from './login/services/get-current-filial.service';
import { GetCurrentCultureService } from './login/services/get-culture.service';
import { GetInitializationStateService } from './login/services/get-initialization-state.service';
import { Child } from './core/interfaces/child.interface';
import { InitialState } from './core/interfaces/initial-state.interface';
import { MenuTop } from './core/interfaces/menu-top.interface';
import { MenuNavRoutes } from './core/constans/menu-nav.routes';
import { SidenavRoutes } from './core/constans/side-nav.routes';
import { HttpErrorResponse } from '@angular/common/http';
import { DataSaveService } from './core/services/data-save.service';
import { SearchVehicleBoxService } from './core/components/search-vehicle-box/search-vehicle-box.service';
import { environment } from '../environments/environment';
import { ACTIVOS } from './dms/layout/side-nav/activos.enum';
import { MENUS_ACTIVOS } from './dms/layout/menu-nav/menus-activos.enum';
import { MarcadorFavoritoService } from './shared/components/marcardor-favorito/marcador-favorito.service';
import { PanelControlChilds } from './core/constans/panel-control-menu';
import {ShortcutService} from './core/services/shortcut.service';
import {GetCurrentVersionService} from './login/services/get-current-version.service';
import {Subscription, forkJoin} from 'rxjs';

@Component({
    selector: 'dms-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
@AutoUnsubscribe()
export class AppComponent implements OnInit, AfterViewChecked, AfterViewInit {
    title = 'dms';
    loading = false;
    subsLoading: Subscription;
    subsRouter: Subscription;
    es_chrome: boolean;
    es_firefox: boolean;
    es_opera: boolean;
    es_ie: boolean;
    es_ie11: boolean;
    navegador: string;
    culture: any;
    // interfacesToCheck: any;
    urlBase: string;
    fromFlex: boolean;
    moduloCode: number;
    sectionId: number;
    urlSection: string;
    menuTop: MenuTop[] = [];
    child: Child;
    childs: Child[] = [];
    userProfile: any;
    error: string;
    code: string;
    initialState: InitialState;
    childSection: Child;
    constructor(
        private _getInitializationStateService: GetInitializationStateService,
        private _getCurrentCultureService: GetCurrentCultureService,
        private _getCurrentFilialService: GetCurrentFilialService,
        private _getCurrentVersionService: GetCurrentVersionService,
        private toastrService: ToastrService,
        private _getSessionProfileService: GetSessionProfileService,
        private _translateService: TranslateService,
        public _authService: AuthService,
        private _dataSaveService: DataSaveService,
        private translate: TranslateService,
        private loadingService: LoadingService,
        private _searchVehicleBoxService: SearchVehicleBoxService,
        private cdRef: ChangeDetectorRef,
        private favs: MarcadorFavoritoService,
        private router: Router,
        private route: ActivatedRoute,
        public _shortcutService: ShortcutService
    ) {
        this.es_chrome = false;
        this.es_firefox = false;
        this.es_opera = false;
        this.es_ie = false;
        this.es_ie11 = false;
        this.navegador = '';

        this.subsLoading = this.loadingService.getLoading().subscribe(state => {
            this.loading = state;
        });



        this.culture = sessionStorage.getItem('culture');

        if (this.culture) {
            this.setDefaultLanguage();
        }

        this.subsRouter = this.router.events.subscribe(event => {

            if (event instanceof NavigationStart) {
                this.loadingService.setLoading(true);
            }

            if (event instanceof NavigationEnd) {


                if (this._authService.modulesActives !== undefined) {
                    const modText = this.router.url.split('/')[2];
                    const mod = this._authService.modulesActives.find(x => x.route.indexOf(modText) !== -1);

                    if (mod !== -1) {
                        this.setCurrentModule(mod);
                    }


                }
                this.loadingService.setLoading(false);
            }

            if (event instanceof NavigationError) {
                this.loadingService.setLoading(false);
            }
        });

        this.comprobarUrl();
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }

    setCurrentModule(modulo) {
        //  Esto resetearia los valores del resto de pantallas pero de momento creo que es mejor dejarlo
        // if( this.currentModule !==  this.moduloActivo){
        //    this.resetearValoresPantallas();
        // }
        let currentModule;
        if (modulo.Code === 99) {
            currentModule = 10;
            modulo.Childs = PanelControlChilds;
        } else {
            currentModule = modulo.Code;
        }
        const auxChild = modulo.Childs[0];
        this._dataSaveService.setChild(auxChild);
        // this._authService.setDataOptionMenu(auxChild);
        this._authService.setCurrentModule(modulo);
        this._authService.setModuloActivo(currentModule); // se actualiza el modulo
    }

    ngOnInit() {

        this.loadFavoritos();

        this.es_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
        this.es_firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        this.es_opera = navigator.userAgent.toLowerCase().indexOf('opera') > -1;
        this.es_ie = window.navigator.userAgent.indexOf('MSIE/') > -1; // ie<11
        this.es_ie11 = window.navigator.userAgent.indexOf('Trident/') > -1;  // ie11


        if (this.es_chrome) {
            this.navegador = 'chrome';
        } else if (this.es_firefox) {
            this.navegador = 'firefox';
        } else if (this.es_opera) {
            this.navegador = 'opera';
        } else if (this.es_ie11) {
            this.navegador = 'IE11'; // ok
            this.msieversion();
        } else if (this.es_ie) {
            this.navegador = 'IE<11';
            this.msieversion();
        } else {
            this.navegador = 'otros';
        }
        this._authService.setNavegador(this.navegador);
    }

    loadFavoritos() {
        const userFavorites = sessionStorage.getItem('userFavorites');
        if (userFavorites) {
            this.favs.setFavorites(
                JSON.parse(userFavorites)
            );
        }
    }

    changeOfRoutes() {
        let activeModule = this._authService.getModuloActivo();
        let previousModule = Number(this._dataSaveService.getData('routerActiveModule'));
        if (previousModule !== activeModule) {
            this._dataSaveService.clearAll();
            this._searchVehicleBoxService.clearAll();
            this._dataSaveService.setData('routerActiveModule', activeModule);
        }
    }

    msieversion() {
        const aux1 = window.navigator.userAgent.indexOf('rv:');
        const aux2 = window.navigator.userAgent.indexOf('MSIE:');

        if (aux1 > -1) {
            const version = parseInt(window.navigator.userAgent.substring(window.navigator.userAgent.indexOf('rv:') + 3, window.navigator.userAgent.indexOf('.', window.navigator.userAgent.indexOf('rv:'))), 10);
        } else if (aux2 > -1) {
            const version = parseInt(window.navigator.userAgent.substring(window.navigator.userAgent.indexOf('MSIE') + 5, window.navigator.userAgent.indexOf('.', window.navigator.userAgent.indexOf('MSIE'))), 10);
        } else {
            const version = parseInt(window.navigator.userAgent.substring(window.navigator.userAgent.indexOf('MSIE') + 5, window.navigator.userAgent.indexOf('.', window.navigator.userAgent.indexOf('MSIE'))), 10);
        }
    }


    setDefaultLanguage() {
        this._authService.setCalendar(JSON.parse(sessionStorage.getItem('culture')));
        this.translate.setDefaultLang(JSON.parse(sessionStorage.getItem('culture')));
        this.translate.use(JSON.parse(sessionStorage.getItem('culture')));
        this.translate.addLangs(['en']);
        moment.locale(JSON.parse(sessionStorage.getItem('culture')));
    }

    comprobarUrl() {
        //pruebas http://star-es-ap.rec.inetpsa.com/core/#/dms?moduloCode=3&sectionId=3003&fromFlex=true
        // http://localhost:4200/dms?moduloCode=3&sectionId=3003&fromFlex=true
        let parametrosUrl = [];
        const hashes = window.location.href.slice(window.location.href.indexOf('#') + 1).split('?');
        this.urlBase = hashes[0].substring(1); // 'dms/workshop/gestion-or'
        if (this.urlBase === 'printPreview') {
            return;
        }

        if (hashes.length > 1) {
            parametrosUrl = hashes[1].split('&');

            const auxModuloCode = parametrosUrl[0].split('=');
            this.moduloCode = Number(auxModuloCode[1]);

            const auxSectionId = parametrosUrl[1].split('=');
            this.sectionId = Number(auxSectionId[1]);

            const auxFromFlex = parametrosUrl[2].split('=');
            this.fromFlex = auxFromFlex[1];
        }

        if (this.fromFlex) {
            //habria que recoger el perfil pero no estamos aun logados
            // es como lo que hicimos en reporting con Oscar a traves de SessionProfile
            this.getInitialState();
            this.SessionProfile();
        }
    }

    SessionProfile() {
        this._getSessionProfileService.sessionProfile().subscribe(data => {
            this.userProfile = data.contents;
            this._authService.setDataContents(this.userProfile); // Guardar Perfil
            this.configureRoles(this.userProfile);

        },
            error => {
                this.error = error.error.ErrorMessage;
            }
        );
    }

    configureRoles(userProfile) {
        this._authService.setClientCode(userProfile.Company.CLIENTCODE); //
        this._authService.setCompanyCode(userProfile.Company.CompanyId);
        const appModules = userProfile.AppModules;
        // const menuTop: MenuTop[] = [];

        for (const modules of appModules) {
            if (modules.Childs !== null && modules.Childs.length > 0) {
                const mt = modules;
                mt.route = MenuNavRoutes[mt.Code];
                const childs: Child[] = [];

                for (const child of mt.Childs) {

                    if (environment.production) {
                        if (this.isMenuActive(child.ID)) {
                            child.route = SidenavRoutes[child.ID];
                            childs.push(child);
                        }
                    } else {
                        child.route = SidenavRoutes[child.ID];
                        childs.push(child);
                    }
                }
                mt.Childs = childs;
                // this.menuTop.push(mt); // ant
                if (environment.production) {
                    MENUS_ACTIVOS.forEach((key: any, vals: any) => {
                        if (mt.Code === key) {
                            this.menuTop.push(mt);
                        }
                    });
                } else {
                    this.menuTop.push(mt);
                }
            }
        }

        sessionStorage.setItem('menuTop', JSON.stringify(this.menuTop));

        const nuevoModuloCode = this.redefinirModulo();

        const childsModulo = this.menuTop[nuevoModuloCode].Childs;
        this.searchChild(childsModulo, this.sectionId);
        this._authService.setCurrentModule(this.menuTop[nuevoModuloCode]);

        this._authService.setModuloActivo(this.menuTop[nuevoModuloCode].Code);
        this._authService.actualizarColor(this.menuTop[nuevoModuloCode].Code);
        this._authService.descripcionModulo(this.menuTop[nuevoModuloCode].Code);

        /* Cargo datos del perfil de usuario */
        this._authService.setUserProfile(userProfile);
        this._authService.setCustomerCode(userProfile.Company.ContractNumber);
        this._authService.setCustomerId(userProfile.Company.DefaultWarrantyCustomerCode);
        this._authService.setCompanyCode(userProfile.Company.CompanyId);
        this._authService.setClientCode(userProfile.Company.CLIENTCODE);
        this._authService.setUserRole(userProfile.CurrentUser.Role);

        if (userProfile.PermissionsList) {
            this._authService.setUserPermissionsList(userProfile.PermissionsList);
        } else {
            this._authService.setUserPermissionsList(null);
        }


        const moduloChilds = this.menuTop[nuevoModuloCode].Childs;
        this.urlSection = '';
        moduloChilds.forEach(item => {

            if (item.ID === this.sectionId) {
                this.urlSection = item.route;
            }
        });
        this.router.navigate([this.urlSection]);

        /********PRUEBA**********/
        // Pruebas WindowService.open con id
        // en urlSection hay esto"/dms/general/gestion-vehiculos"
        //  const auxPruebaRuta = 'http://localhost:4200/#' + this.urlSection;

        //  const auxPruebaRuta = 'http://star-es-ac.rec.inetpsa.com/'
        //  const configuracion_ventana = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,replace=true';
        //  window.open(auxPruebaRuta, 'desdeFlex', configuracion_ventana);

    }
    isMenuActive(id) {
        return ACTIVOS.find(x => x === id);
    }
    redefinirModulo() {
        let newModuleCode = 0;
        this.menuTop.forEach((key: any, index: any) => {
            if (key.Code === this.moduloCode) {
                newModuleCode = index;
            }
        });
        return newModuleCode;
    }

    searchChild(childsModulo, sectionId) {
        childsModulo.forEach(item => {
            if (item.ID === sectionId) {
                this._authService.setDataOptionMenu(item);
            }
        });

    }

    setDefaultLanguageNew(culture) {//nuevo
        sessionStorage.setItem('culture', JSON.stringify(culture));
        this._translateService.setDefaultLang(JSON.parse(sessionStorage.getItem('culture')));
        this._translateService.use(JSON.parse(sessionStorage.getItem('culture')));
        this._translateService.addLangs(['en']);
        moment.locale(JSON.parse(sessionStorage.getItem('culture')));
    }

    getInitialState() {
        const initialState: InitialState = {};

        forkJoin([
            this._getCurrentFilialService.post<string>(),
            this._getCurrentCultureService.post<string>(),
            this._getCurrentVersionService.post<string>(),
            this._getInitializationStateService.post<number>()
        ]).subscribe(result => {
            initialState.filial = result[0];

            initialState.culture = result[1].substring(0,2);
            this.setDefaultLanguageNew(initialState.culture);

            initialState.version = result[2];

            initialState.state = result[3];

            sessionStorage.setItem('initialState', JSON.stringify(initialState));
            this.route.snapshot.data.initialState = initialState;
        }, error => {
            this.handleInitialStateError(error)
        });
    }

    handleInitialStateError(error) {
        if (error instanceof HttpErrorResponse) {
            this.toastrService.error(error.error.ErrorCode, error.error.ErrorMessage, {
                closeButton: true,
                timeOut: 5000,
                onActivateTick: true
            });

        } else {

            this._translateService.get('labels.alert').subscribe(text => {
                this.toastrService.error(error.error.ErrorMessage, text, {
                    closeButton: true,
                    timeOut: 5000,
                    onActivateTick: true
                });
            }
            );
        }
    }

}
